import { TuiDataListDropdownManagerModule } from '@taiga-ui/kit';
import { TUI_IS_MOBILE_RES, TuiDataListModule, TuiHostedDropdownModule } from '@taiga-ui/core';
import { TuiActiveZoneModule } from '@taiga-ui/cdk';
import { TranslateModule } from '@ngx-translate/core';
import { Maybe } from '@iss/libs/graphql';
import {
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
} from '@angular/core';
import { AsyncPipe, NgIf } from '@angular/common';

import { ImpersonateContext } from '../impersonate';

import { IsFalsePipe } from '@iss/wo-common/pipes';

@Component({
  selector: 'wo-avatar-menu',
  templateUrl: './avatar-menu.component.html',
  styleUrls: [ './avatar-menu.component.scss' ],
  standalone: true,
  imports: [
    AsyncPipe,
    IsFalsePipe,
    NgIf,
    TranslateModule,
    TuiActiveZoneModule,
    TuiDataListDropdownManagerModule,
    TuiDataListModule,
    TuiHostedDropdownModule,
  ],
})
export class AvatarMenuComponent {
  public readonly isMobileRes$ = inject(TUI_IS_MOBILE_RES);

  @Input() public impersonateContext: Maybe<ImpersonateContext>;
  @Input() public canSeeSwitchContextPage: Maybe<boolean>;
  @Output() public readonly logout = new EventEmitter();
  @Output() public readonly impersonation = new EventEmitter();
  @Output() public readonly goToAccount = new EventEmitter();
  @Output() public readonly goToContext = new EventEmitter();
}
